module.exports = __webpack_public_path__ + "img/1371.c5410c19.gif";